import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { polarisProductDatesSettingsEntryPoint } from '@atlassian/jira-spa-apps-polaris-settings-dates/entrypoint.tsx';

export const polarisProductDatesSettingsPageEntryPoint = createPageEntryPoint({
	main: polarisProductDatesSettingsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});
